// extracted by mini-css-extract-plugin
export default {"subcategoriesRow":"s_bn","subcategoryColumn":"s_bp","articleLink":"s_bq","articleCoverImage":"s_br","articleTitle":"s_bs","articleMetaDescription":"s_bV"};